import React from "react";

class Guide extends React.Component {
  render() {
    const { x, y, pageHeight, pageWidth, index, zoom } = this.props;
    const axis = x === undefined ? "y" : "x";
    const guideStyle = (axis) => {
      if (axis === "x") {
        return {
          height: pageHeight,
          width: 1,
          position: "absolute",
          transform: `translate(${x - 0.5}px, ${0}px)`,
          borderWidth: `0 ${1 / zoom}px 0 0px`,
          borderColor: "#3767F6",
          borderStyle: "solid",
        };
      } else {
        return {
          height: 1,
          width: pageWidth,
          position: "absolute",
          transform: `translate(${0}px, ${y - 0.5}px)`,
          borderWidth: `0 0 ${1 / zoom}px 0`,
          borderColor: "#3767F6",
          borderStyle: "solid",
        };
      }
    };
    return (
      <div
        key={index}
        data-id={index}
        style={guideStyle(axis)}
      ></div>
    );
  }
}

export default Guide
